import { useRouter } from 'next/router';

import ErrorBaseView from '@/components/tax-refund/common/view/ErrorView/ErrorBaseView';
import { AUTH_PATHS } from '@/lib/constants/paths';
import { ErrorBaseViewController } from '@/lib/types/layout.ts';

export const Unauthorized = () => {
  const router = useRouter();
  const errorBaseViewController: ErrorBaseViewController = {
    graphic: (
      <img
        src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/common/iconography/icg_exclamation-mark-dimmed_sm.svg`}
        className={'w-[88px] h-[88px]'}
        alt={''}
      />
    ),
    title: '서비스 이용을 위해\n로그인을 해주세요',
    description: '유효시간이 지나 로그인이 필요해요.',
    primaryButtonText: '로그인',
    onPrimaryButtonClick: () => router.push({ pathname: AUTH_PATHS.로그인, query: router.query })
  };

  return <ErrorBaseView viewController={errorBaseViewController} />;
};




